export enum IrdaStatus {
    OFF,
    TRIGGER,
    TRIGGER_ACCEPTED,
    DONE,
    ERROR
}